// src/Pages/VisionMission.js
import React, { useState } from 'react';
import './VisionMission.css';

const VisionMission = () => {
  const [activeTab, setActiveTab] = useState('vision');

  return (
    <>
      
      <div className="vision-mission-container">
        <div className="tab-buttons">
          <button
            className={activeTab === 'vision' ? 'active' : ''}
            onClick={() => setActiveTab('vision')}
          >
            Vision
          </button>
          <button
            className={activeTab === 'mission' ? 'active' : ''}
            onClick={() => setActiveTab('mission')}
          >
            Mission
          </button>
        </div>

        <div className="tab-content">
          {activeTab === 'vision' ? (
            <div>
              <h2>Our Vision</h2>
              <p>
                To revolutionize early-stage breast cancer detection by making infrared imaging technology accessible, non-invasive, and widely adopted.
              </p>
            </div>
          ) : (
            <div>
              <h2>Our Mission</h2>
              <p>
                To provide affordable, reliable, and user-friendly infrared imaging solutions that assist in the early diagnosis and monitoring of breast health for women globally.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default VisionMission;
